/* ICON CULTURE — Motion (scroll reveals). Aditivo y a prueba de fallos:
   el JS es quien AÑADE la clase que oculta; si el JS no corre, el contenido
   se ve normal. Respeta prefers-reduced-motion. */
(function () {
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (mq.matches || !('IntersectionObserver' in window)) return;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    var sections = Array.prototype.slice.call(
      main.querySelectorAll(':scope > .shopify-section')
    );
    // El hero (primera sección) se muestra de inmediato, sin reveal.
    sections.shift();
    if (!sections.length) return;

    sections.forEach(function (el) { el.classList.add('ic-reveal'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ic-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    sections.forEach(function (el) { io.observe(el); });

    // Failsafe: pase lo que pase, nada queda oculto tras 2.5s.
    setTimeout(function () {
      sections.forEach(function (el) { el.classList.add('ic-in'); });
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ICON CULTURE — Header sólido al scrollear (legibilidad del navbar).
   Añade la clase ic-header-solid a <html> cuando bajas; el CSS le da fondo
   crema para que las letras del menú siempre se lean. Independiente del
   reduce-motion (es legibilidad, no animación). */
(function () {
  var root = document.documentElement, ticking = false;
  function upd() {
    root.classList.toggle('ic-header-solid', (window.scrollY || window.pageYOffset || 0) > 80);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(upd); }
  }, { passive: true });
  upd();
})();
